import React from 'react';
import './assets/css/App.css';
import './assets/css/Legal.css';
import './assets/css/Cookies.css';

import Router from './Router';
import { CookieConsentProvider } from './context/CookieConsentContext';

function App() { 
  return (
    <CookieConsentProvider>
      <div className="App">
        <Router/>    
      </div>
    </CookieConsentProvider>
  );
}

export default App;
